import type { ModalStatelessProps } from '@/components/ModalStateless';
import { ConfirmationModal } from '@/components/molecules/ConfirmationModal';
import { useMessages } from '@/hooks/messages';

import { assumptionDeletionConfirmationModalMessageDefinitions } from './messages';

type AssumptionDeletionConfirmationModalProps = Pick<ModalStatelessProps, 'open' | 'onClose'> & {
  onConfirm: () => void;
};

export const AssumptionDeletionConfirmationModal: React.FC<
  AssumptionDeletionConfirmationModalProps
> = ({ open, onClose, onConfirm }) => {
  const messages = useMessages(assumptionDeletionConfirmationModalMessageDefinitions);

  return (
    <ConfirmationModal
      title={messages.title()}
      warningMessage={messages.warningMessage()}
      confirmButtonLabel={messages.confirmButton()}
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
};
